export function checkAllParticipantsVoted(participants) {
  if (participants.length < 1) return false;

  let votedParticipantsCount = 0;
  participants.forEach((participant) => {
    if (participant.status !== 'awaiting') votedParticipantsCount++;
  });

  return votedParticipantsCount === participants.length;
}